import { call, put } from 'redux-saga/effects'
import { toast } from 'react-toastify'
import {
  calculatePoints,
  calculateCash,
  calculateEncashablePoints,
  validateRedemption,
} from '../requests/rewardService'
import {
  setPointsResult,
  setCashResult,
  setEncashmentResult,
  setRedemptionResult,
  setLoading,
  setError,
} from '../../slices/rewardCalculatorSlice'

function getErrorMessage(e) {
  try {
    const msg = e.response?.data?.message || e.response?.data?.error || e.message
    return typeof msg === 'string' ? msg : String(msg)
  } catch {
    return 'An unexpected error occurred'
  }
}

export function* handleCalculatePoints(action) {
  try {
    yield put(setLoading(true))
    const { data } = yield call(calculatePoints, action.payload)
    yield put(setPointsResult(data))
  } catch (e) {
    yield put(setLoading(false))
    const errorMsg = getErrorMessage(e)
    toast.error(errorMsg)
    yield put(setError(errorMsg))
  }
}

export function* handleCalculateCash(action) {
  try {
    yield put(setLoading(true))
    const { data } = yield call(calculateCash, action.payload)
    yield put(setCashResult(data))
  } catch (e) {
    yield put(setLoading(false))
    const errorMsg = getErrorMessage(e)
    toast.error(errorMsg)
    yield put(setError(errorMsg))
  }
}

export function* handleCalculateEncashment(action) {
  try {
    yield put(setLoading(true))
    const { data } = yield call(calculateEncashablePoints, action.payload)
    yield put(setEncashmentResult(data))
  } catch (e) {
    yield put(setLoading(false))
    const errorMsg = getErrorMessage(e)
    toast.error(errorMsg)
    yield put(setError(errorMsg))
  }
}

export function* handleValidateRedemption(action) {
  try {
    yield put(setLoading(true))
    const { data } = yield call(validateRedemption, action.payload)
    yield put(setRedemptionResult(data))
  } catch (e) {
    yield put(setLoading(false))
    const errorMsg = getErrorMessage(e)
    toast.error(errorMsg)
    yield put(setError(errorMsg))
  }
}
